const translations = {
  title: "Settings",
  subtitle: "Business profile, team permissions, security, integrations, and developer controls.",
  pilotNoticeStrong: "",
  pilotNoticeDesc: "",
  // Tabs
  tab_firm: "Firm Profile",
  tab_language: "Language",
  tab_users: "Users & Roles",
  tab_smtp: "Email / SMTP",
  tab_whatsapp: "WhatsApp",
  tab_gst: "GST & Tax",
  tab_hardware: "Hardware",
  tab_backup: "Backup",
  tab_security: "Security Log",
  tab_branches: "Branches",
  tab_workflow: "Workflow",
  // Firm Profile
  firmProfile: "Firm Profile",
  shopName: "Shop Name",
  tagline: "Tagline",
  phone: "Phone",
  email: "Email",
  address: "Address",
  city: "City",
  gstin: "GSTIN",
  website: "Website",
  logoUrl: "Logo URL",
  uploadLogo: "Upload Logo",
  primaryColor: "Brand Primary Color",
  goldAccentColor: "Gold Accent Color",
  signatureLabelLeft: "Signature Label (Left)",
  signatureLabelRight: "Signature Label (Right)",
  terms: "Invoice Terms & Conditions",
  saveFirmProfile: "Save Firm Profile",
  // Language
  appPanelLanguage: "App Panel Language",
  receiptPrintLanguage: "Receipt & Print Language",
  whatsAppDispatchLanguage: "WhatsApp Language",
  staffMemberLanguage: "Staff Member Language",
  languageTabDesc:
    "Select default operating languages. Multi-lingual: English, Hindi, Bengali, and Marathi.",
  lang_en: "English",
  lang_hi: "Hindi (हिन्दी)",
  lang_mr: "Marathi (मराठी)",
  lang_bn: "Bengali (বাংলা)",
  // Users & Roles
  users: "Users",
  inviteUser: "Invite User",
  inviteEmail: "Email to Invite",
  inviteRole: "Role",
  inviteBranch: "Branch",
  sendInvite: "Send Invite",
  generatedCode: "Invitation Code",
  copyLink: "Copy Invite Link",
  revokeInvite: "Revoke",
  role_superOwner: "Super Owner",
  role_administrator: "Administrator",
  role_manager: "Manager",
  role_cashier: "Cashier",
  role_staff: "Staff",
  role_ceo: "CEO (View Only)",
  role_karigar: "Karigar",
  // SMTP
  smtpHost: "SMTP Host",
  smtpPort: "SMTP Port",
  smtpUser: "SMTP Username",
  smtpPass: "SMTP Password",
  smtpFrom: "From Email",
  smtpFromName: "From Name",
  smtpProvider: "Email Provider",
  testEmail: "Test Email",
  sendTestEmail: "Send Test Email",
  smtpSaved: "SMTP settings saved.",
  // WhatsApp
  waProvider: "WhatsApp Provider",
  waApiKey: "API Key",
  waPhoneId: "Phone Number ID",
  waBusinessId: "Business Account ID",
  waWebhookToken: "Webhook Token",
  testWhatsApp: "Test WhatsApp",
  // GST
  gstRegistered: "GST Registered",
  defaultGstRate: "Default GST Rate",
  hsnCode: "Default HSN Code",
  // Security Log
  securityLog: "Security Log",
  logDate: "Date",
  logAction: "Action",
  logUser: "User",
  logDetail: "Detail",
  // Backup
  backupTitle: "Data Backup",
  exportData: "Export All Data",
  importData: "Import Data",
  lastBackup: "Last Backup",
  // Branch settings (in settings context)
  branchSettings: "Branch Settings",
  branchName: "Branch Name",
  branchCode: "Branch Code",
  branchType: "Branch Type",
  branchAddress: "Branch Address",
  branchPhone: "Branch Phone",
  saveBranchSettings: "Save Branch Settings",
  localizedCoverage: "localized",
};

export default translations;
